import Keycloak from "keycloak-js";
import store, { persistor } from "./../store";
import loginActionTypes from "./../actions/types/login.action.type";
import { API_BASE_URL, roleConfigUrls, getExceptionMessage } from "./helper";
import axios from "axios";
import fiConfig from "./../fiConfig.json";
import { getLoggedInPortalDetails, isAgreeementAccepted} from "./bpportal-common-utils.js";
import { RoleType } from "../constants/sharedConstants.js";
import i18next from "i18next";
import actions from "../actions";
import { ACTION_TYPES } from "../services/serviceLevelMonitoring.service.js";

let fiNumber = 50;
let type;

const base_url = window.location.origin;
const {fiConfigKey, currentEnv} = getLoggedInPortalDetails();
const LOGIN_SERVICE_LEVEL_MONITORING_PENDING_KEY = "erpsLoginServiceLevelMonitoringPending";
const SERVICE_LEVEL_MONITORING_DEDUPE_KEY_PREFIX = "sl-monitoring";

if (fiConfig[fiConfigKey]) {
  ({ fiNumber, type } = fiConfig[fiConfigKey]);
}

let realm = "";
let clientId = "";
if (fiNumber == 26) {
  realm = "dyedurham_erps_pcb";
  clientId = "pcb_client_account";
} else if (fiNumber == 40) {
  realm = "dyedurham_erps_manulife";
  clientId = "manulife_client_account";
} else if (fiNumber == 16) {
  realm = "dyedurham_erps_hsbc";
  clientId = "hsbc_client_account";
} else if (fiNumber == 37) {
  realm = "dyedurham_erps_mcu";
  clientId = "mcu_client_account";
} else if (fiNumber == 88) {
  realm = "dyedurham_erps_tfx";
  clientId = "tfx_client_account";
} else if (fiNumber == 50) {
  realm = "dyedurham_erps_dnd";
  clientId = "dnd_client_account";
} else if (fiNumber == 61) {
  realm = "dyedurham_erps_tangerine";
  clientId = "tangerine_client_account";
} else if (fiNumber == 36) {
  realm = "dyedurham_erps_motus";
  clientId = "motus_client_account";
} else if (fiNumber == 99 && type == "classic") {
  realm = "dyedurham_erps_bmo_classic";
  clientId = "bmo_classic_client_account";
} else if (fiNumber == 99 && (type == "webportal" || type == "billpay")) {
  realm = "dyedurham_erps_bmo_webportal";
  clientId = "bmo_webportal_client_account";
} else if (fiNumber == 10 && type == "classic") {
  realm = "dyedurham_erps_cibc_classic";
  clientId = "cibc_classic_client_account";
} else if (fiNumber == 10 && (type == "webportal" || type == "billpay")) {
  realm = "dyedurham_erps_cibc_webportal";
  clientId = "cibc_webportal_client_account";
} else if (fiNumber == 2) {
  realm = "dyedurham_erps_bns";
  clientId = "bns_client_account";
} else if (fiNumber == 200) {
  realm = "dyedurham_erps_bns";
  clientId = "demo_canact_client_account";
} else if (fiNumber == 777) {
  realm = "dyedurham_erps_billpay_portal";
  clientId = "billpay_portal_client_account";
}

let keycloakUrl = "";
if (currentEnv == "erpsqa") {
  keycloakUrl = "https://sso.erpsqa.ca/auth";
} else if (currentEnv == "erpsdev") {
  keycloakUrl = "https://sso.erpsdev.ca/auth";
} else if (currentEnv == "erpsstage02") {
  keycloakUrl = "https://sso.erpsstage02.ca/auth";
} else if (currentEnv == "erpsstage") {
  keycloakUrl = "https://sso.erpsstage.ca/auth";
} else if (currentEnv == "can-act-billpay") {
  keycloakUrl = "https://sso.can-act-billpay.com/auth";
} else {
  //keycloakUrl = "http://localhost:7070";
  keycloakUrl = "https://sso.erpsdev.ca/auth";
}

const _kc = new Keycloak({
  url: keycloakUrl,
  realm: realm,
  clientId: clientId,
  redirectUri: `${base_url}/auth-redirect`,
});

const { dispatch } = store;

let initPromise = null;

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (props) => { // TODO: remove property 't' from props
  if (initPromise) {
    return initPromise;
  }

  initPromise = _kc
    .init({
      pkceMethod: "S256",
      redirectUri: `${base_url}/auth-redirect`,
      checkLoginIframe: false
    })
    .then((authenticated) => {
      if (props.setIsLoggedIn) {
        props?.setIsLoggedIn(true);
      }
      if (authenticated) {
        axios
          .post(
            API_BASE_URL() + "/users/authenticate",
            {
              fiNumber: getTokenParsed()?.attr_fi_number,
              userId: getTokenParsed()?.preferred_username,
              roleId: getTokenParsed()?.role_id,
              portalType: localStorage.getItem("type")
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getToken(),
                "Login-UserId": getTokenParsed()?.preferred_username,
              },
            }
          )
          .then((res) => {
            // props.setLoginPending(false);
            res.token = getToken();
            dispatch(success(res));

            const data = JSON.parse(JSON.stringify(res.data));
            if (data) {
              localStorage.setItem("fiNumber", data.fiNumber);
              const {
                role: { role_type },
              } = data;

              if (!isAgreeementAccepted(data, role_type)) {
                props.props.history.push("/welcome-page");
              } else {
                if (data.statusCode !== "I") {
                  // if (data.changePasswordIndex == "N") {
                  if (data.emailAddress || data.emailAddress != "") {
                    const roleId = data?.role?.role_id;
                    let path;
                    if (roleId == 7) {
                      path =
                        data?.fiNumber == 10 || data?.fiNumber == 16
                          ? "/manage-billers"
                          : "/review-transactions";
                    }
                    else if (localStorage.getItem("type") === "billpay" && (roleId === 1 || roleId === 2))
                      path = "/dashboard";
                    else
                      path = roleConfigUrls[roleId] || "/dashboard";

                    props.props.history.push(path);
                  } else {
                    props.props.history.push("/account-settings");
                  }
                  // } else {
                  //   if (data.emailAddress || data.emailAddress != "") {
                  //     props.props.history.push("/update-password");
                  //   } else {
                  //     props.props.history.push("/account-settings");
                  //   }
                  // }
                }
              }

              // save login service level monitoring data after successful login only
              saveLoginServiceLevelMonitoringData();
            }

            if (data.languageCode == "E") {
              i18next.changeLanguage("en");
            } else if (data.languageCode === "F") {
              i18next.changeLanguage("fr");
            }
          })
          .catch((error) => {
            //The error processing (3 lines below) was commented out since this code was written on Oct 10, 2023.
            // const errMessage = getExceptionMessage(error);
            // props.setLoginPending(false);
            // dispatch({ type: loginActionTypes.AUTHENTICATION_FAIL, error: "Login failure" });

            //The error response below developed in Jun 2025
            if (props.setErrorMessage) {
              var errorMsg = getExceptionMessage(error);
              if (errorMsg)
                props.setErrorMessage(errorMsg);
            }
          });

        // document.getElementById('loggedIn').innerText = getUsername() + ' is logged in' ;

        // const parseValue = getTokenParsed();

        // document.getElementById('token').innerText =  JSON.stringify(getTokenParsed());
      } else {
        // document.getElementById("loggedIn").innerText = "not logged";
      }
    }).catch((error) => {
//console.log("*** initKeycloak - ERROR-2: " + listProps(error, true));
    });

  return initPromise;

  function success(data) {
    return { type: loginActionTypes.AUTHENTICATION_SUCCESS, data };
  }
};

function resolveLoginSlaRequestStartTime(tokenParsed) {
  const authTimeIso = new Date(tokenParsed.auth_time * 1000).toISOString();
  const raw = getLoginStartCookie();
  if (!raw || typeof raw !== "string") return authTimeIso;
  const ms = Date.parse(raw.trim());
  if (Number.isNaN(ms)) return authTimeIso;
  return new Date(ms).toISOString();
}

const saveLoginServiceLevelMonitoringData = () => {
  if (sessionStorage.getItem(LOGIN_SERVICE_LEVEL_MONITORING_PENDING_KEY) === "1") {
    sessionStorage.removeItem(LOGIN_SERVICE_LEVEL_MONITORING_PENDING_KEY);

    const tokenParsed = getTokenParsed();
    const requestStartTime = resolveLoginSlaRequestStartTime(tokenParsed);

    const dedupeKey = populateServiceLevelMonitoringDedupeKey(tokenParsed);

    if (!(dedupeKey && localStorage.getItem(dedupeKey) === "1")) {
      const requestEndTime = new Date(
        performance.timeOrigin + performance.now()
      ).toISOString();

      dispatch(
        actions.serviceLevelMonitoringActions.recordData({
          actionType: ACTION_TYPES.LOGIN,
          fiNumber: tokenParsed?.attr_fi_number,
          loggedInUserId: tokenParsed?.preferred_username,
          requestStartTime,
          requestEndTime,
          requestParams: JSON.stringify({ dedupeKey, kcTokenAuthTime: new Date(tokenParsed.auth_time * 1000).toISOString() })
        })
      ).then((ok) => {
        if (ok && dedupeKey) localStorage.setItem(dedupeKey, "1");
      });
    }
  }
};

function populateServiceLevelMonitoringDedupeKey(tokenParsed) {
  const user = tokenParsed?.preferred_username;
  if (!user) return null;

  return `${SERVICE_LEVEL_MONITORING_DEDUPE_KEY_PREFIX}:${user}:${tokenParsed.auth_time}`;
}

function removeServiceLevelMonitoringDedupeKey(tokenParsed) {
  const dedupeKey = populateServiceLevelMonitoringDedupeKey(tokenParsed);

  localStorage.removeItem(dedupeKey);
}

const LOGIN_START_COOKIE_NAME = "login_start";

/**
 * Reads the `login_start` cookie (e.g. set from a Keycloak login theme on a shared parent domain).
 * @returns {string|null} Cookie value, URI-decoded when possible; null if absent or not in browser.
 */
function getLoginStartCookie() {
  let value = null;
  if (typeof document !== "undefined" && document.cookie) {
    const prefix = `${LOGIN_START_COOKIE_NAME}=`;
    const part = document.cookie
      .split(";")
      .map((c) => c.trim())
      .find((c) => c.startsWith(prefix));
    if (part) {
      const raw = part.slice(prefix.length);
      try {
        value = decodeURIComponent(raw);
      } catch {
        value = raw;
      }
    }
  }
  return value;
}

const doLogin = () => {
  sessionStorage.setItem(LOGIN_SERVICE_LEVEL_MONITORING_PENDING_KEY, "1");
  _kc.login();
};

const doLogout = (...args) => {
  removeServiceLevelMonitoringDedupeKey(getTokenParsed());
  return _kc.logout(...args);
};

const getToken = () => _kc.token;

const getTokenParsed = () => _kc.tokenParsed;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback) =>
  _kc.updateToken(5).then(successCallback).catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  updateToken,
  getUsername,
  hasRole,
  base_url,
};

export default UserService;
